import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ComboBoxDropdownComponent, ComboBoxDropdownGroupComponent, ComboBoxDropdownOptionComponent} from './combo-box-dropdown.component';
import {ListGroupModule} from '../list-group/list-group.module';
import {InputModule} from '../input/input.module';
import {A11yModule} from '@angular/cdk/a11y';

@NgModule({
  declarations: [
    ComboBoxDropdownOptionComponent,
    ComboBoxDropdownGroupComponent,
    ComboBoxDropdownComponent
  ],
  imports: [
    CommonModule,
    ListGroupModule,
    FormsModule,
    InputModule,
    A11yModule,
  ],
  exports: [
    ComboBoxDropdownOptionComponent,
    ComboBoxDropdownGroupComponent,
    ComboBoxDropdownComponent
  ]
})
export class ComboBoxDropdownModule {
}
